import { useEffect, useMemo, useState } from 'react';
import { ArrowRight, Command, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function CommandMenu({ items = [] }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setOpen((value) => !value);
      }
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  const filtered = useMemo(() => {
    const needle = query.trim().toLowerCase();
    if (!needle) return items;
    return items.filter((item) => `${item.label} ${item.group ?? ''} ${item.keywords ?? ''}`.toLowerCase().includes(needle));
  }, [items, query]);

  if (!open) return null;
  return <div className="fixed inset-0 z-[90] overflow-hidden bg-black/75 p-4 pt-[10vh] backdrop-blur-sm" onMouseDown={() => setOpen(false)}>
    <div className="mx-auto flex max-h-[72vh] max-w-2xl flex-col overflow-hidden border border-cyan-300/15 bg-[#081019] shadow-[0_30px_100px_rgba(0,0,0,.65)]" onMouseDown={(event) => event.stopPropagation()}>
      <div className="flex h-14 shrink-0 items-center gap-3 border-b border-white/8 px-4"><Search size={17} className="text-cyan-300"/><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search pages, operations, or settings" className="h-full flex-1 bg-transparent text-sm outline-none placeholder:text-slate-600"/><span className="border border-white/10 px-2 py-1 text-[9px] text-slate-600">ESC</span></div>
      <div className="scrollbar min-h-0 flex-1 overflow-y-auto p-2">
        {filtered.map((item) => {
          const Icon = item.icon;
          return <button key={item.path} type="button" onClick={() => { navigate(item.path); setOpen(false); setQuery(''); }} className="group flex h-11 w-full items-center gap-3 border border-transparent px-3 text-left hover:border-white/8 hover:bg-white/[.035]">
            <span className="grid size-7 place-items-center border border-white/10 text-cyan-300"><Icon size={14}/></span>
            <span className="min-w-0 flex-1"><span className="block truncate text-[12px] font-bold text-slate-200">{item.label}</span><span className="block truncate text-[8px] font-black uppercase tracking-[.14em] text-slate-700">{item.group}</span></span>
            <ArrowRight size={13} className="text-slate-700 transition group-hover:translate-x-0.5 group-hover:text-cyan-300"/>
          </button>;
        })}
        {!filtered.length && <div className="grid min-h-44 place-items-center text-center"><div><Command size={22} className="mx-auto text-slate-700"/><p className="mt-3 text-xs font-bold text-slate-400">No command found</p></div></div>}
      </div>
      <div className="flex h-9 shrink-0 items-center justify-between border-t border-white/8 px-3 text-[8px] font-bold uppercase tracking-[.14em] text-slate-700"><span>Navigate with search</span><span>Ctrl K</span></div>
    </div>
  </div>;
}
